export type SearchCommandMode = 'all' | 'patient' | 'appointment' | 'invoice' | 'command';

export interface ParsedSearchCommandQuery {
  mode: SearchCommandMode;
  /** Remainder after prefix (trimmed). */
  term: string;
  /** True when a scope prefix was detected. */
  hasPrefix: boolean;
}

const PREFIX_RULES: Array<{ mode: SearchCommandMode; pattern: RegExp }> = [
  { mode: 'command', pattern: /^(?:>|command)\s*(.*)$/i },
  { mode: 'patient', pattern: /^(?:p|patient)\s+(.*)$/i },
  { mode: 'appointment', pattern: /^(?:a|appt|appointment)\s+(.*)$/i },
  { mode: 'invoice', pattern: /^(?:i|inv|invoice)\s+(.*)$/i },
];

/**
 * Parses command-palette prefixes: `p`, `a`, `i`, `>` / `command`.
 * Bare queries stay in `all` mode.
 */
export function parseSearchCommandQuery(raw: string): ParsedSearchCommandQuery {
  const trimmed = raw.trim();
  if (!trimmed) {
    return { mode: 'all', term: '', hasPrefix: false };
  }

  if (trimmed === '>' || /^command$/i.test(trimmed)) {
    return { mode: 'command', term: '', hasPrefix: true };
  }

  for (const rule of PREFIX_RULES) {
    const match = trimmed.match(rule.pattern);
    if (match) {
      return {
        mode: rule.mode,
        term: (match[1] ?? '').trim(),
        hasPrefix: true,
      };
    }
  }

  return { mode: 'all', term: trimmed, hasPrefix: false };
}

export function searchModePlaceholder(mode: SearchCommandMode): string {
  switch (mode) {
    case 'patient':
      return 'Search patients by name, phone, or ID…';
    case 'appointment':
      return 'Search appointments…';
    case 'invoice':
      return 'Search invoices…';
    case 'command':
      return 'Filter commands…';
    default:
      return 'Search or run a command… Try p Mehta or > book';
  }
}
